import isEmail from 'validator/lib/isEmail'
import { emailRegExp } from '~/core/constants/regex'

export const isValidEmail = (email: string): boolean => {
  return emailRegExp.test(email) && isEmail(email)
}
